import { createMarketplaceEventFactory } from '../index';
export const getPageViewedEvent = createMarketplaceEventFactory('Marketplace', 'Page Viewed');